import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getIsInMaintenancePeriod } from "../../features/System/actions";
import { apiGet } from "@redriver/cinnamon";

const MaintenanceBanner = ({ message, isActive }) => {
    if(!isActive) return null;

    return (
    <div className="maintenance-banner">
        {message}
    </div>);    
}

export default MaintenanceBanner;